import titleize from 'titleize'

export const firstName = (name: string) => titleize(name.split(' ')[0])
